module.exports = __webpack_public_path__ + "media/images/emblems/Niederlenz-blason-0065bba102b0d9f2a9fe1fb5c9a6399f.svg";